<template>
  <div class="w-full">
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left px-2">
        <vs-input
          v-model.trim="questionsByPage[index].content"
          class="w-full"
          @blur="validateUrl"
          :label="$t(textLabel)"
          :placeholder="$t(textLabel)"
        />
      </vs-col>
    </vs-row>
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <Default :index="index" :label="$t('MODULE.viewer.labelViewInformation')"></Default>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left">
        <Default
          :index="index"
          :label="$t('MODULE.viewer.labelOrientation')"
          option="Orientation"
          property="orientation"
        ></Default>
      </vs-col>
    </vs-row>
  </div>
</template>

<script type="text/javascript">
import Default from "../../componentsToQuestions/DefaultSelect.vue";
import { mapState } from "vuex";
export default {
  props: ["index"],
  components: { Default },
  methods: {
    /**
     * Valida la estructura del url
     */
    validateUrl() {
      var pattern = new RegExp(/^(https)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi);
      const _url = this.questionsByPage[this.index].content;

      if (!!!pattern.test(_url)) {
        this.questionsByPage[this.index].content = "";
        this.$vs.notify({
          title: "Danger",
          text: "No es una url válida.",
          color: "danger",
          position: "top-right"
        });
      } else {
        const url = new URL(_url);
        if (!(url.protocol === "https:")) {
          this.questionsByPage[this.index].content = "";
          this.$vs.notify({
            title: "Danger",
            text: "La url debe contener protocolo de seguridad https.",
            color: "danger",
            position: "top-right"
          });
        }
      }
    }
  },
  computed: {
    ...mapState("resource", ["questionsByPage"]),
    /**
     * Otiene un título para uso informactivo del componente para el usuario.
     */
    textLabel() {
      if (this.questionsByPage[this.index].inputType === "web") return "MODULE.viewer.labelInputWeb";
      return "MODULE.viewer.labelInputDocument";
    }
  }
};
</script>
